import type { Messages } from './types.ts';

export const en = {
  'lang.uz': 'Oʻzbekcha',
  'lang.ru': 'Русский',
  'lang.en': 'English',

  'greeting.morning': 'Good morning, {name}',
  'greeting.day': 'Good afternoon, {name}',
  'greeting.evening': 'Good evening, {name}',
  'greeting.night': 'Good night, {name}',

  'home.title': 'Fairy tales',
  'home.profile': 'Profile',
  'home.tonight': 'Tonight’s story',
  'home.listen': 'Listen',
  'home.continue': 'Continue listening',
  'home.minutesLeft': '{count} min left',
  'home.all': 'All stories',
  'home.language': 'Story language',

  'quota.free': '{count} free',
  'quota.freeLeft': '{count} free left',
  'quota.none': 'No free stories left',
  'quota.premium': 'Premium',

  'story.minutes': '{count} min',
  'story.play': 'Play',
  'story.playing': 'Now playing',
  'story.listened': 'Listened',
  'story.locked': 'Premium',
  'story.draft': 'Draft',

  'player.label': 'Player',
  'player.close': 'Minimize',
  'player.more': 'More',
  'player.tonight': 'Tonight’s story',
  'player.story': 'Story',
  'player.withText': 'Listen with text',
  'player.ended': 'Story ended',
  'player.meta': 'Story · {minutes} min · ages {ageMin}–{ageMax}',
  'player.textCard': 'Story text',
  'player.textCardHint': 'Open the text',
  'player.play': 'Play',
  'player.pause': 'Pause',
  'player.back15': 'Back 15 seconds',
  'player.forward15': 'Forward 15 seconds',
  'player.prev': 'Previous story',
  'player.next': 'Next story',
  'player.seek': 'Story time',
  'player.buffering': 'Loading…',
  'player.speed': 'Speed',
  'player.timer': 'Timer',
  'player.timerOff': 'Off',
  'player.timerEnd': 'To end',
  'player.text': 'Text',
  'player.textLoading': 'Loading the text…',
  'player.textError': 'Couldn’t load the text',
  'player.error': 'Audio didn’t load. Check your connection.',
  'player.retrying': 'Connection lost — trying again…',

  'menu.share': 'Share',
  'menu.shareText': 'Fonus Ertak — a new audio story for kids every night 🌙',
  'menu.storyLang': 'Story language',
  'menu.textSize': 'Text size',
  'menu.textSizeNormal': 'Normal',
  'menu.textSizeLarge': 'Large',
  'menu.report': 'Report a problem',
  'menu.cancel': 'Cancel',

  'sleep.title': 'Sleep timer',
  'sleep.hint': 'When time is up, the story gently fades out and stops',
  'sleep.off': 'Off',
  'sleep.minutes': '{count} minutes',
  'sleep.end': 'End of story',
  'sleep.done': 'Done',

  'night.title': 'Night mode',
  'night.wake': 'Wake screen',
  'night.fade': 'The story ends softly · volume fades out',
  'night.plus5': '+5 min',
  'night.stop': 'Stop now',

  'end.goodnight': 'Good night, {name}!',
  'end.body': '“{title}” has ended. Tomorrow’s story arrives at {time}.',
  'end.next': 'Next story',
  'end.stopHere': 'Stop here',
  'end.pickOther': 'Choose another story',

  'paywall.close': 'Close',
  'paywall.badge': 'Premium story',
  'paywall.title': 'A new story every night',
  'paywall.subStory': '“{title}” and every other story unlock with Premium.',
  'paywall.subGeneric': 'Every story unlocks with Premium.',
  'paywall.expiredTitle': 'Your subscription has ended',
  'paywall.expiredSubtitle': 'Renew to keep listening',
  'paywall.valNightly': 'A new story every night',
  'paywall.valArchive': 'The full story library',
  'paywall.valTextNight': 'Every story — with text and night mode',
  'paywall.plans': 'Plan',
  'paywall.save': 'Save {percent}%',
  'plan.week': 'Week',
  'plan.month': 'Month',
  'plan.year': 'Year',
  'plan.perMonth': '{price} per month',
  'paywall.payClick': 'Pay with Click',
  'paywall.payPayme': 'Pay with Payme',
  'paywall.payStars': 'Pay with Telegram Stars',
  'paywall.payFake': 'Test payment (dev)',
  'paywall.proof': '100,000+ families are already with Fonus Kids',
  'paywall.noAutoCharge': 'No automatic charges',
  'paywall.how': 'How it works',
  'paywall.stepToday': 'Today',
  'paywall.stepTodayBody': 'Premium unlocks right away',
  'paywall.stepTodayStory': 'Premium unlocks right away — including “{title}”',
  'paywall.stepNightly': 'Every night at {time}',
  'paywall.stepNightlyBody': 'A new story and a gentle reminder',
  'paywall.stepRemind': '3 days before it ends',
  'paywall.stepRemindBody': 'We remind you in Telegram first',
  'paywall.restore': 'Restore purchase',
  'paywall.restoreNone': 'No active subscription found — message support',
  'paywall.offer': 'Public offer',
  'paywall.privacy': 'Privacy',

  'gate.title': 'For grown-ups',
  'gate.body': 'Choose the right answer to continue to payment',
  'gate.wrong': 'Try again',
  'gate.cancel': 'Cancel',

  'payment.checking': 'Checking status automatically',
  'payment.waitingTitle': 'Confirming your payment',
  'payment.waitingBody':
    'Confirm the payment in the {provider} app. Premium unlocks by itself as soon as it goes through.',
  'payment.pendingBody': 'The payment isn’t confirmed yet. Check again in a moment.',
  'payment.stepCreated': 'Order created',
  'payment.stepConfirm': 'Confirm in {provider}',
  'payment.stepUnlock': 'Premium unlocks',
  'payment.order': '{provider} · order № {orderNo}',
  'payment.planWeek': 'Weekly plan',
  'payment.planMonth': 'Monthly plan',
  'payment.planYear': 'Yearly plan',
  'payment.open': 'Open {provider}',
  'payment.check': 'Check payment',
  'payment.cancel': 'Cancel',
  'payment.help': 'Need help?',
  'payment.successChip': 'Premium active',
  'payment.successTitle': 'Sweet dreams, {name}!',
  'payment.successBody': 'A new story every night and the full story library are now yours.',
  'payment.receipt': '{plan} · {price}',
  'payment.until': 'Until {date} · receipt in Telegram',
  'payment.remind': 'Remind me every night at {time}',
  'payment.remindSub': 'Let’s build the bedtime habit together',
  'payment.listen': 'Listen to a story',
  'payment.home': 'Back to home',
  'payment.failedTitle': 'Payment didn’t go through',
  'payment.failedBody': 'Don’t worry — you haven’t been charged.',
  'payment.why': 'Usually it’s because',
  'payment.reasonFunds': 'Not enough funds on the card',
  'payment.reasonCancelled': 'The payment was cancelled in {provider}',
  'payment.reasonNetwork': 'The internet connection dropped',
  'payment.retry': 'Try again',
  'payment.support': 'Message support',

  'profile.title': 'Profile',
  'profile.close': 'Close',
  'profile.premium': 'Premium',
  'profile.active': 'Active',
  'profile.planUntil': '{plan} · until {date}',
  'profile.planWeekly': 'Weekly',
  'profile.planMonthly': 'Monthly',
  'profile.planYearly': 'Yearly',
  'profile.manage': 'Manage',
  'profile.noPremium': 'No Premium',
  'profile.freeLeft': '{count} free stories left',
  'profile.ended': 'Ended {date}',
  'profile.subscribe': 'Subscribe',
  'profile.settings': 'Settings',
  'profile.language': 'Language',
  'profile.reminder': 'Evening reminder',
  'profile.reminderAt': 'Every day at {time}',
  'profile.quality': 'Audio quality',
  'profile.qualityHint': 'Data saver uses less mobile traffic.',
  'profile.help': 'Help',
  'profile.support': 'Message support',
  'profile.version': 'Fonus Ertak {version} · Fonus Kids',

  'quality.auto': 'Auto',
  'quality.low': 'Data saver',
  'quality.high': 'High',

  'welcome.label': 'Welcome',
  'welcome.chip': '{count} {count:story|stories} free',
  'welcome.title': 'A new audio story every day',
  'welcome.body': 'Listen with your child before bed — in Uzbek, Russian and English.',
  'welcome.start': 'Get started',

  'state.emptyTitle': 'No stories in this language yet',
  'state.emptyBody': 'Stories in this language are coming soon. For now, listen in Uzbek.',
  'state.emptyCta': 'Switch to Uzbek',
  'state.emptyUzBody': 'New stories are coming soon.',
  'state.offlineTitle': 'No internet',
  'state.offlineBody': 'Check your connection — the stories will wait for you.',
  'state.retry': 'Try again',
  'state.errorTitle': 'Something went wrong',
  'state.errorBody': 'We couldn’t load the stories. Please try again in a moment.',
  'state.reload': 'Reload',
  'state.expiredTitle': 'Your subscription has ended',
  'state.expiredBody': 'Premium ended on {date}. Renew to keep a new story every night.',
  'state.renew': 'Renew subscription',
  'state.later': 'Later',
  'state.reopenTitle': 'Please reopen the app',
  'state.reopenBody':
    'The app has been open for too long. Close it and open it again from the bot.',
  'state.reopenButton': 'Close',

  'toast.langChanged': 'Language changed',
  'toast.slowNetwork': 'Slow connection — data saver on',
  'toast.offline': 'Offline — showing saved stories',
  'toast.loading': 'Loading',

  'bot.welcome': 'Hello, {name}! 🌙\nA new story every evening. Tap the button to listen.',
  'bot.open': 'Open stories',
  'bot.help':
    'Fonus Ertak — audio stories for kids.\n/start — open stories\n/language — choose language\n/subscription — subscription status\n/help — help',
  /** Chat menu button (setChatMenuButton per chat, in the profile language). */
  'bot.menuButton': 'Stories',
  'bot.cmdStart': 'Open stories',
  'bot.cmdHelp': 'Help',
  'bot.cmdLanguage': 'Choose language',
  'bot.cmdSubscription': 'Subscription status',
  'bot.languagePick': 'Choose a language:',
  'bot.languageSet': 'Language changed: English',
  'bot.subActive': 'Premium is active until {date}.\n{plan}',
  'bot.subNext': 'Next: {plan} from {date}',
  'bot.subGranted': 'Premium is active until {date}.',
  'bot.subNone': 'No Premium. Free stories left: {freeLeft}.',
  'bot.subEndedOn': 'Premium ended on {date}.',
  'bot.buy': 'Get Premium',
  'bot.renew': 'Renew',
  'bot.tonight': 'Tonight’s story is ready 🌙\n“{title}”',
  'bot.tonightNoTitle': 'Tonight’s story is ready 🌙',
  'bot.listen': 'Listen',
  'bot.subExpiring':
    'Premium ends on {date} — {days} {days:day|days} left. Renew so the stories don’t stop.',
  'bot.subEndsToday': 'Today is the last day of Premium. Renew so the stories don’t stop.',
  'bot.subEnded': 'Premium ended today. Renew to keep listening.',
  'bot.receipt':
    'Payment received ✅\nOrder № {orderNo}\n{plan} · {price}\nPremium is active until {date}.',
  'admin.storyReady': '🆕 A new story is ready for review: “{title}”\n{url}',
  'admin.ttsBudget':
    '⛔ Voicing not started: not enough ElevenLabs credits. Need ≈{need}, {remaining} left; this month {monthUsed} of {limit}.',
  'admin.ttsBudgetUnavailable':
    '⛔ Voicing not started: could not check the ElevenLabs balance ({detail}).',
  'admin.contentFailed': '⚠️ Job “{type}” failed: {error}',
  'admin.newPayment': '💳 New payment № {orderNo}\n{plan} · {price} · {provider}',
  'admin.broadcastFailed': '⚠️ Evening broadcast: {failed} errors ({sent} sent of {total}).',
  'admin.broadcastCrashed': '⚠️ Evening broadcast stopped: {error}',
  'admin.report':
    '📊 Report for {date}\nNew users: {newUsers}\nListeners: {listeners} · listens: {listens} ({completed} to the end)\nPayments: {payments} · {revenue}\nActive Premium: {premium}\nBroadcast: {broadcast}',
  'admin.reportNoBroadcast': 'none',
  'admin.reportBroadcast': '{sent} sent · {blocked} blocked · {failed} errors',
} as const satisfies Messages;
